/* eslint-disable extra-rules/no-commented-out-code */
import useInjectReducerAndSaga from '@tcp/core/src/utils/useInjectReducerAndSaga';
import { createFilteredReducer } from '@tcp/core/src/utils/redux.util';
import { PRODUCT_TAB_LIST_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';

export default async () => {
  const [ProductTabListReducer, ProductTabListSaga] = await Promise.all([
    import(/* webpackChunkName: "ProductTablist" */ './ProductTabList.reducer'),
    import(/* webpackChunkName: "ProductTablist" */ './ProductTabList.saga'),
  ]);

  const filteredProductTabListReducer = createFilteredReducer(
    ProductTabListReducer.default,
    PRODUCT_TAB_LIST_REDUCER_KEY
  );

  useInjectReducerAndSaga(
    { key: 'ProductTabList', reducer: filteredProductTabListReducer },
    { key: 'ProductTabListSaga', saga: ProductTabListSaga.default }
  );
  return null;
};
